import { useState, useEffect } from 'react';

export const useMouseTracking = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isMouseMoving, setIsMouseMoving] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    let rafId: number;
    let lastTime = 0;
    
    // Cache window dimensions to avoid forced reflow
    let cachedWidth = window.innerWidth;
    let cachedHeight = window.innerHeight;
    
    const updateDimensions = () => {
      cachedWidth = window.innerWidth;
      cachedHeight = window.innerHeight;
    };

    const handleMouseMove = (e: MouseEvent) => {
      const now = Date.now();
      
      // Throttle to 60fps (16ms)
      if (now - lastTime < 16) return;
      lastTime = now;

      rafId = requestAnimationFrame(() => {
        setMousePosition({
          x: (e.clientX / cachedWidth) * 2 - 1, // Normalize to -1 to 1
          y: (e.clientY / cachedHeight) * 2 - 1
        });
        
        setIsMouseMoving(true);
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => setIsMouseMoving(false), 100);
      });
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    window.addEventListener('resize', updateDimensions, { passive: true });
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('resize', updateDimensions);
      clearTimeout(timeoutId);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return { mousePosition, isMouseMoving };
};